module.exports = __webpack_public_path__ + "static/media/house_greyjoy.b33e54b5.png";